module.exports = __webpack_public_path__ + "static/gallery8-6bb8bc296b6c9c7cfd6a43eae39cfb5b.jpg";